import React from 'react'

const Cp_st_rev = () => {
    return (
        <div className='container'>
            <h1>Reverse a stack </h1>
            <p>Write a program to reverse a stack using recursion. You are not allowed to use loop constructs like while, for..etc, and you can only use the following ADT functions on Stack S:&nbsp;<br/>
            isEmpty(S)&nbsp;<br/>
            push(S)&nbsp;<br/>
            pop(S)</p>
            <p>The idea of the solution is to hold all values in Function Call Stack until the stack becomes empty. When the stack becomes empty, insert all held items one by one at the bottom of the stack.&nbsp;<br/>
            For example, let the input stack be&nbsp;&nbsp;</p>
            <pre className='output'> {`   1  <-- top
    2
    3
    4  `}  </pre>
    <pre className='output'>{`First 4 is inserted at the bottom.
    4 <-- top

Then 3 is inserted at the bottom
    4 <-- top    
    3

Then 2 is inserted at the bottom
    4 <-- top    
    3 
    2
     
Then 1 is inserted at the bottom
    4 <-- top    
    3 
    2
    1`}
</pre>
<p>So we need a function that inserts at the bottom of a stack using the above given basic stack function.<br/>
<strong>void insertAtBottom((): </strong>First pops all stack items and stores the popped item in function call stack using recursion. And when stack becomes empty, pushes new item and all items stored in call stack.<br/>
<strong>void reverse():</strong> This function mainly uses insertAtBottom() to pop all items one by one and insert the popped items at the bottom.&nbsp;&nbsp;</p>
<div class="containers">
        <div class="line number1 index0 alt2"><code class="comment">// C++ code to reverse a&nbsp;</code></div>
        <div class="line number2 index1 alt1"><code class="comment">// stack using recursion</code></div>
        <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
        <div class="line number4 index3 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number6 index5 alt1"><code class="comment">// using std::stack for&nbsp;</code></div>
        <div class="line number7 index6 alt2"><code class="comment">// stack implementation</code></div>
        <div class="line number8 index7 alt1"><code class="plain">stack&lt;</code><code
                        class="keywords">char</code><code class="plain">&gt; st;</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number10 index9 alt1"><code class="comment">// intializing a string to store</code></div>
        <div class="line number11 index10 alt2"><code class="comment">// result of reversed stack</code></div>
        <div class="line number12 index11 alt1"><code class="plain">string ns;</code></div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number14 index13 alt1"><code class="comment">// Below is a recursive function&nbsp;</code>
        </div>
        <div class="line number15 index14 alt2"><code class="comment">// that inserts an element</code></div>
        <div class="line number16 index15 alt1"><code class="comment">// at the bottom of a stack.</code></div>
        <div class="line number17 index16 alt2"><code class="keywords">char</code> <code
                        class="plain">insert_at_bottom(</code><code class="keywords">char</code> <code
                        class="plain">x)</code></div>
        <div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
        <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code><code class="plain">(st.size() == 0)</code></div>
        <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(x);</code></div>
        <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">else</code></div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number25 index24 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// All items are held in Function Call</code></div>
        <div class="line number27 index26 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Stack until we reach end of the stack</code></div>
        <div class="line number28 index27 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// When the stack becomes empty, the</code></div>
        <div class="line number29 index28 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// st.size() becomes 0, the above if&nbsp;</code></div>
        <div class="line number30 index29 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// part is executed and the item is&nbsp;</code></div>
        <div class="line number31 index30 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// inserted at the bottom</code></div>
        <div class="line number32 index31 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number33 index32 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">char</code> <code class="plain">a = st.top();</code></div>
        <div class="line number34 index33 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.pop();</code></div>
        <div class="line number35 index34 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">insert_at_bottom(x);</code></div>
        <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number37 index36 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// push allthe items held in&nbsp;</code></div>
        <div class="line number38 index37 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Function Call Stack</code></div>
        <div class="line number39 index38 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// once the item is inserted</code></div>
        <div class="line number40 index39 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// at the bottom</code></div>
        <div class="line number41 index40 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(a);</code></div>
        <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number43 index42 alt2"><code class="plain">&#125;</code></div>
        <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number45 index44 alt2"><code class="comment">// Below is the function that</code></div>
        <div class="line number46 index45 alt1"><code class="comment">// reverses the given stack using</code></div>
        <div class="line number47 index46 alt2"><code class="comment">// insert_at_bottom()</code></div>
        <div class="line number48 index47 alt1"><code class="keywords">char</code> <code
                        class="plain">reverse()</code></div>
        <div class="line number49 index48 alt2"><code class="plain">&#123;</code></div>
        <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code><code class="plain">(st.size()&gt;0)</code></div>
        <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number52 index51 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number53 index52 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Hold all items in Function&nbsp;</code></div>
        <div class="line number54 index53 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Call Stack until we</code></div>
        <div class="line number55 index54 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// reach end of the stack&nbsp;</code></div>
        <div class="line number56 index55 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">char</code> <code class="plain">x = st.top();</code></div>
        <div class="line number57 index56 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.pop();</code></div>
        <div class="line number58 index57 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">reverse();</code></div>
        <div class="line number59 index58 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number60 index59 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Insert all the items held</code></div>
        <div class="line number61 index60 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// in Function Call Stack</code></div>
        <div class="line number62 index61 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// one by one from the bottom&nbsp;</code></div>
        <div class="line number63 index62 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// to top. Every item is</code></div>
        <div class="line number64 index63 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// inserted at the bottom&nbsp;</code></div>
        <div class="line number65 index64 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">insert_at_bottom(x);</code></div>
        <div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number67 index66 alt2"><code class="plain">&#125;</code></div>
        <div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number69 index68 alt2"><code class="comment">// Driver Code</code></div>
        <div class="line number70 index69 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number71 index70 alt2"><code class="plain">&#123;</code></div>
        <div class="line number72 index71 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// push elements into&nbsp;</code></div>
        <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// the stack</code></div>
        <div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(</code><code class="string">'1'</code><code class="plain">);</code></div>
        <div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(</code><code class="string">'2'</code><code class="plain">);</code></div>
        <div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(</code><code class="string">'3'</code><code class="plain">);</code></div>
        <div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(</code><code class="string">'4'</code><code class="plain">);</code></div>
        <div class="line number79 index78 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout&lt;&lt;</code><code class="string">"Original Stack"</code><code
                        class="plain">&lt;&lt;endl;</code></div>
        <div class="line number81 index80 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// print the elements&nbsp;</code></div>
        <div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// of original stack</code></div>
        <div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout&lt;&lt;</code><code class="string">"1"</code><code
                        class="plain">&lt;&lt;</code><code class="string">" "</code><code
                        class="plain">&lt;&lt;</code><code class="string">"2"</code><code
                        class="plain">&lt;&lt;</code><code class="string">" "</code></div>
        <div class="line number85 index84 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&lt;&lt;</code><code class="string">"3"</code><code
                        class="plain">&lt;&lt;</code><code class="string">" "</code><code
                        class="plain">&lt;&lt;</code><code class="string">"4"</code></div>
        <div class="line number86 index85 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&lt;&lt;endl;</code></div>
        <div class="line number87 index86 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// function to reverse&nbsp;</code></div>
        <div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// the stack</code></div>
        <div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">reverse();</code></div>
        <div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout&lt;&lt;</code><code class="string">"Reversed Stack"</code></div>
        <div class="line number92 index91 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&lt;&lt;endl;</code></div>
        <div class="line number93 index92 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// storing values of reversed&nbsp;</code></div>
        <div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// stack into a string for display</code></div>
        <div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">while</code><code class="plain">(!st.empty())</code></div>
        <div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number98 index97 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">char</code> <code class="plain">p=st.top();</code></div>
        <div class="line number99 index98 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.pop();</code></div>
        <div class="line number100 index99 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">ns+=p;</code></div>
        <div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number102 index101 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">//display of reversed stack</code></div>
        <div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout&lt;&lt;ns[3]&lt;&lt;</code><code class="string">" "</code><code
                        class="plain">&lt;&lt;ns[2]&lt;&lt;</code><code class="string">" "</code></div>
        <div class="line number105 index104 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&lt;&lt;ns[1]&lt;&lt;</code><code class="string">" "</code><code
                        class="plain">&lt;&lt;ns[0]&lt;&lt;endl;</code></div>
        <div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">0;</code></div>
        <div class="line number107 index106 alt2"><code class="plain">&#125;</code></div>
        <div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
</div>
<div className='output'>
Output: <br /> <br />
 
Original Stack  <br />
1  2  3  4  <br />
Reversed Stack <br />
4  3  2  1 <br />
     </div>

        </div>
    )
}

export default Cp_st_rev
